__turbopack_context__.v({
  "content": "EventFAQs-module-scss-module__kChHtq__content",
  "title": "EventFAQs-module-scss-module__kChHtq__title",
});
